import { axiosInstance } from './axiosInstance';
import { message } from 'antd';

export class FormsService {
    static async getForms(options, setIsLoading) {
        try {
            const params = {};
            for (let key in options) {
                if (options[key]) {
                    params[key] = options[key];
                }
            }

            setIsLoading(true);
            let response = await axiosInstance.get(`/admin/`, { params });
            setIsLoading(false);

            return response;
        } catch (error) {
            message.error(error.message);
            setIsLoading(false);
            console.error(error);
        }
    }

    static async getForm(id) {
        try {
            const response = await axiosInstance.get(`/admin/${id}`);
            return response;
        } catch (error) {
            message.error(error.message);
            console.error(error);
        }
    }

    static async deleteForm(id, setIsLoading) {
        try {
            setIsLoading(true);
            const response = await axiosInstance.delete(`/admin/${id}`);
            setIsLoading(false);
            return response;
        } catch (error) {
            message.error(error.response.data);
            setIsLoading(false);
            console.error(error);
        }
    }

    static async getFormsMetadata() {
        try {
            const response = await axiosInstance.get(`/admin/metadata`);
            return response;
        } catch (error) {
            message.error(error.message);
            console.error(error);
        }
    }

    static async setForm(form, message) {
        try {
            const response = await axiosInstance.post('/admin', { id: form.id, name: form.name });
            if (response) {
                message.success('Информация о добавленной форме и строка подключения отправлены на почту');
            }

            return response;
        } catch (error) {
            message.error(error?.response?.data);
            console.error(error);
        }
    }

    static async editForm(form, message) {
        try {
            const response = await axiosInstance.put(`/admin/${form.id}`, { name: form.name, allow: form.allow });
            if (response) {
                message.success('Форма изменена');
            }

            return response;
        } catch (error) {
            message.error(error?.response?.data);
            console.error(error);
        }
    }
}
